module.exports = __webpack_public_path__ + "img/activity.daf23f79.png";